import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import useAuth from 'data/hooks/useAuth';
import FullScreenBackground from 'components/FullScreenBackground';
import Login from 'components/Login';

const Guest = () => {
  const { login } = useAuth();
  return (
    <FullScreenBackground>
      <Switch>
        <Route exact path="/login">
          <Login login={login} />
        </Route>
        <Redirect to="/login" />
      </Switch>
    </FullScreenBackground>
  );
};

export default Guest;
